// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8300) return "js/frontend/8300.js";
	if (chunkId === 9588) return "js/frontend/9588.js";
	// return url for filenames based on template
	return undefined;
};